import { Component, OnInit, OnDestroy } from '@angular/core';
import { ContentService } from 'src/app/_core/_services/content.service';
import { BehaviorService } from 'src/app/_core/_services/behavior.service';
import { EventsService } from 'src/app/_core/_services/events.service';
import { Router } from '@angular/router';
import { GlobalService } from 'src/app/_core/global.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit, OnDestroy {

  public categories$: any;
  public categoryConten$: any = {};
  public sliderGames: any;
  private contentCount: number = window.innerWidth >= 768 ? 18 : 9;
  public sliding: boolean = false;

  public homeSlideConfig: any = {
    slidesToScroll: 1,
    slidesToShow: 1,
    infinite: true,
    autoplay: true,
    arrows: false,
    dots: true
  }

  constructor(
    private neo: ContentService,
    private beh: BehaviorService,
    private events: EventsService,
    private router: Router,
    public global: GlobalService
  ) {
    this.beh._categories.subscribe(categ => {
      this.categories$ = categ;
      if (!!this.categories$) {
        if (!!this.beh.slideCallResp_.value) {
          this.sliderGames = this.beh.slideCallResp_.value;
        } else {
          if (!!this.global.propConfs$.neo[this.contentLang()].slideShowCatId) {
            this.neo.loadCategoryContent(this.global.propConfs$.neo[this.contentLang()].slideShowCatId, 5).subscribe(val => {
              this.sliderGames = val?.result || [];
              !!this.sliderGames?.length && this.beh.slideCallResp_.next(this.sliderGames);
            }, () => { this.sliderGames = [] });
          } else {
            let catIdList = [];
            for (let cat of categ) { catIdList.push(cat.catId) }
            this.neo.loadLatestContent(catIdList, 5).subscribe(val => {
              this.sliderGames = val?.result || [];
              !!this.sliderGames?.length && this.beh.slideCallResp_.next(this.sliderGames);
            }, () => { this.sliderGames = [] });
          }
        }

        if (!!this.beh.homeContCallResp_.value) {
          this.categoryConten$ = this.beh.homeContCallResp_.value;
        } else {
          this.neo.loadContentsByCategories([this.categories$[0].catId, this.categories$[1].catId, this.categories$[2].catId], this.contentCount, 1, 'CATEGORY').subscribe(val => {
            for (let cont of val?.result || []) { this.categoryConten$[cont.catId] = cont.medias }
            !!this.categoryConten$ && this.beh.homeContCallResp_.next(this.categoryConten$);
          });
        }
      }
    })
  }

  ngOnInit() {
    this.events.eventStart({ eventType: 'HOME_PAGE_ACCESS', eventCategory: 'ACCESS' });
    this.beh.isInHome.next(true);
  }

  ngOnDestroy() {
    this.beh.isInHome.next(false);
  }

  private contentLang() {
    return JSON.parse(localStorage.u || '{}').l || this.global.propConfs$.langs[0];
  }

  public navToGame(catId, gameId) {
    !this.sliding && this.router.navigate([`/game/${catId}/${gameId}`], { queryParamsHandling: 'merge' });
  }

}
